<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
// Firebase App (the core Firebase SDK) is always required and must be listed first
import * as firebase from "firebase/app";

// If you enabled Analytics in your project, add the Firebase SDK for Analytics
import "firebase/analytics";

// Add the Firebase products that you want to use
import "firebase/database";

export default {
  mounted() {    
    // Set the configuration for your app
    // TODO: Replace with your project's config object
    var config = {
      apiKey: "AIzaSyD4bFVy3vo8vdQidBcPAZq_5QYKJ-ZVFmg",
      authDomain: "codenames-the-game.firebaseapp.com",
      databaseURL: "https://codenames-the-game.firebaseio.com",
    };
    firebase.initializeApp(config);

    // Get a reference to the database service
    const database = firebase.database();
    this.$store.commit("initDb", database);
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000;
  width: 100%;
  height: 100%;
}

body,
html {
  width: 100%;
  height: 100%;
  margin: 0px;
}

p {
  margin: 0px;
  font-family: "Courier";
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
